<h2 mat-dialog-title mat-dialog-draggable-title>{{'title.timestamp_list' | translate}}
    <button type="button" class="close" aria-label="Close" cdkFocusInitial (click)="onClickCancelButton()">
        <span aria-hidden="true">&times;</span>
    </button>
</h2>
<mat-divider></mat-divider>
<p class="mt-3" >{{'title.total_timestamp' | translate}} <strong>{{totalFlie}}</strong></p>
<p style="font-style: italic;"><strong>{{'title.note' | translate}}</strong> {{'title.note_timestamp' | translate}}</p>
<mat-dialog-content>
    <nz-table style="padding-top: 15px;" #rowsTable nzBordered [nzData]="nzData" [nzShowPagination]="false" [nzFrontPagination]="false"
        class="ant-table-no-placeholder-border-bottom">
        <thead style=" background-color: #f2f2f2;">
            <tr>
                <th class="text-center" nzWidth="55px" rowspan="2">
                    {{ "timestamp_detail.index" | translate }}
                </th>

                <th class="text-center" rowspan="2">
                    {{ "timestamp_detail.sign_date" | translate }}
                </th>

                <th class="text-center" rowspan="2">
                    {{ "timestamp_detail.enterprise" | translate }}
                </th>
              <ng-container *ngIf="signType === -1">
                <th class="text-center" nzEllipsis="true" rowspan="2">
                  {{"timestamp_detail.total_sign" | translate}}
                </th>
                <th class="text-center" colspan="3" style="padding: 8px !important;">
                  {{"timestamp_detail.sign_success" | translate}}
                </th>
              </ng-container>
            </tr>
            <tr>
              <ng-container *ngIf="signType === -1">
              <th class="text-center" style="width: 10% !important; padding: 0 !important;">
                {{ "timestamp_detail.quantity" | translate }}
                <p style="margin: 0 !important;">(A)</p>
              </th>
              </ng-container>

              <ng-container *ngIf="signType == 1">
                <th class="text-center" style="width: 10% !important; padding: 0 !important;">
                  {{ "timestamp_detail.number_of_signed_files" | translate }}
                  <p style="margin: 0 !important;">(A)</p>
                </th>

              </ng-container>

                <th class="text-center" style="width: 15% !important; padding: 0 !important;">
                    {{ "timestamp_detail.price" | translate }}
                    <p style="margin: 0 !important;">(B)</p>
                </th>
                <th class="text-center" style="width: 20% !important; min-width: 20% !important; padding: 0 !important;" nzEllipsis="true">
                    {{"timestamp_detail.money"| translate}}
                    <p style="margin: 0 !important;">(A*B)</p>
                </th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let data of nzData; let i = index;">
                    <td class="text-center">{{ i + 1 }}</td>
                    <td nz-tooltip
                    [nzTooltipTitle]="data.signDate" class="text-center">
                        {{ data.signDate ? data.signDate : null }}
                    </td>

                    <td>
                        {{ data.customer ? data.customer : null }}
                    </td>
                    <td class="text-center">
                        {{ data.totalSign ? data.totalSign : null}}
                    </td>
                    <ng-container *ngIf="signType === -1">
                      <td class="text-center">
                        {{ data.quantity ? data.quantity : null}}
                      </td>
                    </ng-container>

                    <td class="text-center">
                        {{ (data.price ? data.price : null) | number}}
                    </td>
                    <td class="text-right">
                        {{ (data.money ? data.money : null) | number}}
                    </td>
                </tr>
                <tr class="text-primary" style="background-color: #f2f2f2; font-weight: 700;">
                    <td colspan="2"></td>
                    <td nzEllipsis="true" [attr.colspan]="signType ==  -1 ? 4 : 3" >
                        {{"timestamp_detail.total_money"| translate}}
                    </td>
                    <td class="text-right" nzEllipsis="true" colspan="1">
                        {{totalMoney | number}}
                    </td>
                </tr>
        </tbody>

    </nz-table>
</mat-dialog-content>
<mat-divider class="mt-3"></mat-divider>
<mat-dialog-actions align="center">
    <!-- đóng popup -->
    <button mat-stroked-button color="primary" class="mr-3" (click)="onClickCancelButton()" type="button">
        <mat-icon class="mr-0">cancel</mat-icon>
        {{'button.close' | translate}}
    </button>


</mat-dialog-actions>
